import { combineReducers } from "redux"
import { setterReducer } from "../common/redux"
import * as t from "./actionTypes"
import * as embedTypes from "../embed/actionTypes"

const initAge = {
  value: "",
  unit: "years",
}

export const pov = setterReducer("", t.SET_POV)
export const ageInputAttempted = setterReducer(false, t.SET_AGE_INPUT_ATTEMPTED)
export const name = setterReducer("", t.SET_NAME)
export const profile_id = setterReducer("", t.SET_PROFILE_ID)
export const ageError = setterReducer(null, t.SET_AGE_ERROR)
export const infantExplanation = setterReducer(null, t.SET_INFANT_EXPLANATION)

export const age = (state = initAge, action) => {
  switch (action.type) {
    case t.SET_AGE:
      return { ...state, ...action.payload }
    case embedTypes.GET_CUSTOM_SUCCESS:
      return action.payload.age ? { exact: action.payload.age } : state
    default:
      return state
  }
}

export const sex = (state = "", action) => {
  switch (action.type) {
    case t.SET_SEX:
      return action.payload
    case embedTypes.GET_CUSTOM_SUCCESS:
      return action.payload.sex ? action.payload.sex : state
    default:
      return state
  }
}

const identifiers = combineReducers({
  pov,
  sex,
  age,
  ageInputAttempted,
  name,
  profile_id,
  ageError,
  infantExplanation
})

export { identifiers as default }



// WEBPACK FOOTER //
// ./assets/identifiers/reducer.js